module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am466-4789160e9f358c063320863bc9550eed.jpg";